let associates_slider = (function( $ ) {

	let $wrapper,
		$slider,
		slide_speed = 3000;

	let _init = function() {
		$wrapper = $( '.associates-slider-wrapper' );
		$slider  = $wrapper.find( '.slider' );

		if ( $slider.length > 0 ) {
			_setup_slider();
		}
	};

	let _setup_slider = function() {
		$slider.on( 'initialized.owl.carousel', function( event ) {
			_slider_initialised( event, $slider )
		} );

		let $slide_count = $slider.find( '.item' ).length;

		$slider.owlCarousel( {
			autoplay: true,
			autoplayTimeout: slide_speed,
			nav: false,
			dots: false,
			responsive: {
				0 : {
					items : 2,
				},
				992 : {
					items: 4,
				},
			},
		} );
	};

	let _slider_initialised = function( event, $slider ) {
		$slider.find( '.owl-item .slide' ).addClass( 'initialised' );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = associates_slider;